<template>
    <div>

        <Card :header="$t('availabilityAnalysis')" overlay :loading="requestData.getLoading()">

            <ErrorMessage :value="requestData.getError()" />

            <template #nav>
                <div class="d-flex gap-3 flex-column">
                    <div class="d-flex gap-3">
                        <MultiselectAvailableCampaigns :disabled="requestData.getLoading()" @changeTrackBy="campaigns = $event" @change="loadData()" />
                        <Multiselect
                            v-show="showProductGroupsResults"
                            :fetch-options-function="fetchSpaceGroups"
                            :placeholder="$t('productGroup')"
                            searchable
                            track-by="id"
                            label="name"
                            select-label=""
                            :disabled="requestData.getLoading()"
                            show-checkboxes
                            show-selected
                            multiple
                            preselect-all
                            :close-on-select="false"
                            :clear-on-select="false"
                            class="width-200"
                            @changeTrackBy="groups = $event"
                            @change="showProductGroupsResults && loadData()"
                        />
                        <FormCategoryTreeSelect
                            v-show="!showProductGroupsResults"
                            ref="FormCategoryTreeSelect"
                            v-model="categories"
                            :disabled="requestData.getLoading()"
                            class="width-200"
                            @change="!showProductGroupsResults && loadData()"
                        />
                    </div>
                    <div class="d-flex gap-3 justify-content-end align-items-center">
                        <b-form-checkbox v-model="showProductGroupsResults" switch>{{ $t('showResultsForProductGroups') }}</b-form-checkbox>
                    </div>
                </div>
            </template>

        </Card>

        <div class="d-flex gap-4 flex-column">

            <StatsWidgets />

            <OffersInTime />

            <AverageAvailabilityOfProductsByStores />

            <AverageAvailabilityByProducts />

            <AvailabilityInTimeAccordingToStores />

        </div>

    </div>
</template>



<script>
    import FormCategoryTreeSelect from '@/components/common/FormCategoryTreeSelect.vue';
    import Multiselect from '@/components/common/Multiselect.vue';
    import MultiselectAvailableCampaigns from '@/components/common/MultiselectAvailableCampaigns.vue';
    import StatsWidgets from './StatsWidgets.vue';
    import OffersInTime from './OffersInTime.vue';
    import AverageAvailabilityOfProductsByStores from './AverageAvailabilityOfProductsByStores.vue';
    import AverageAvailabilityByProducts from './AverageAvailabilityByProducts.vue';
    import AvailabilityInTimeAccordingToStores from './AvailabilityInTimeAccordingToStores.vue';

    export default {
        name: 'AvailabilityAnalysis',
        components: {
            Multiselect,
            FormCategoryTreeSelect,
            StatsWidgets,
            OffersInTime,
            AverageAvailabilityOfProductsByStores,
            AverageAvailabilityByProducts,
            AvailabilityInTimeAccordingToStores,
            MultiselectAvailableCampaigns,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                requestData: this.$req('space/AvailabilityCharts'),
                requestDataCompare: this.$req('space/AvailabilityCharts'),
                requestCampaigns: this.$req('buyboxes/AvailableCampaigns'),
                requestSpaceGroups: this.$req('producerProductGroups/spaceGroups'),
                showProductGroupsResults: false,
                campaigns: [],
                groups: [],
                categories: [],
            };
        },
        computed: {
            spaceId() {
                return this.$store.state.space.currentSpaceId;
            },
            timeRange() {
                return this.parentComponent.timeRange;
            },
            apiParams() {
                const urlParams = { spaceId: this.spaceId };
                const { startDate, endDate } = this.timeRange || {};
                const requestParams = { startDate, endDate };
                if (this.campaigns?.length) requestParams.campaigns = this.campaigns.join(',');
                if (!this.showProductGroupsResults && this.categories?.length) requestParams.categories = this.categories.join(',');
                if (this.showProductGroupsResults && this.groups?.length) requestParams.groups = this.groups.join(',');
                return { urlParams, requestParams };
            },
            data() {
                return this.requestData.getLoading() ? {} : this.requestData.getData() || {};
            },
        },
        watch: {
            spaceId: {
                handler: 'loadData',
            },
            timeRange: {
                handler: 'loadData',
            },
            showProductGroupsResults: {
                handler: 'loadData',
            },
        },
        methods: {
            loadData() {
                this.requestData.get(this.apiParams);
                this.requestDataCompare.get({
                    ...this.apiParams,
                    requestParams: {
                        ...this.apiParams.requestParams,
                        startDate: this.timeRange.compareStartDate,
                        endDate: this.timeRange.compareEndDate,
                    },
                });
            },
            fetchCampaigns() {
                const id = this.$store.getters['plugin/getProducerPlugin'].id;
                return this.requestCampaigns.get({ urlParams: { id, v: 1 } });
            },
            fetchSpaceGroups() {
                return this.requestSpaceGroups.get({ urlParams: { spaceId: this.spaceId } }).then(data => data.items);
            },
        },
        created() {
            this.loadData();
        },
    };
</script>
